<div class="container-fluid pt-2 compact-dashboard">

  <!-- Layout principal en dos columnas -->
  <div class="row h-100">
    <!-- Columna izquierda: Información del dispositivo, estado, contadores y parámetros -->
    <div class="col-lg-6 col-md-12 d-flex flex-column h-100">

      <!-- Información del Dispositivo -->
      <div class="row mb-2">
        <div class="col-12">
          <div class="card h-100">
            <div class="card-header py-2">
              <h6 class="card-title mb-0">
                Información del Dispositivo
              </h6>
            </div>
            <div class="card-body py-2">
              <div class="row">
                <!-- Columna izquierda: Información básica -->
                <div class="col-md-6">
                  <div class="d-flex flex-column gap-3">
                    <!-- Estado -->
                    <div class="text-center">
                      <div class="mb-1">
                        <i class="fas fa-wifi fs-5" [class.text-success]="deviceInfo.alive"
                          [class.text-danger]="!deviceInfo.alive"></i>
                      </div>
                      <small class="text-muted">Estado</small>
                    </div>
                  </div>
                </div>

                <!-- Columna derecha: Información técnica -->
                <div class="col-md-6">
                  <div class="d-flex flex-column justify-content-center h-100 gap-3">
                    <!-- Zona Horaria -->
                    <div>
                      <i class="fas fa-clock text-warning me-1"></i>
                      <strong class="small">Zona Horaria:</strong>
                      <small class="text-muted ms-1"> Madrid/Europa </small>
                    </div>

                    <!-- Última Conexión -->
                    <div>
                      <i class="fas fa-history text-info me-1"></i>
                      <strong class="small">Última Conexión:</strong>
                      <small class="text-muted ms-1"> Sin determinar </small>
                    </div>

                    <!-- Ubicación -->
                    <div>
                      <i class="fas fa-map-marker-alt text-danger me-1"></i>
                      <strong class="small">Ubicación:</strong>
                      <small class="text-muted ms-1">
                        {{ubicacion?.city}}, {{ubicacion?.country}}
                      </small>
                    </div>

                    <!-- Coordenadas -->
                    <div>
                      <i class="fas fa-crosshairs text-secondary me-1"></i>
                      <strong class="small">Coordenadas:</strong>
                      <small class="text-muted ms-1">{{coordenadas?.latitude}}, {{coordenadas?.longitude}}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Contadores y Estado en una fila -->
      <div class="row flex-fill">
        <!-- Contadores -->
        <div class="col-xl-7 col-lg-12 col-md-7 col-sm-12">
          <div class="card mb-2 flex-fill">
            <div class="card-header py-2">
              <h6 class="card-title mb-0 small">
                Contadores
              </h6>
            </div>
            <div class="card-body py-2">
              <!-- Sección Horas -->
              <div class="mb-3">
                <h6 class="text-muted small mb-2 text-center">
                  Horas de Funcionamiento
                </h6>
                <div class="d-flex justify-content-center align-items-center gap-4">
                  <!-- Horas Totales -->
                  <div class="text-center">
                    <div class="data-item">
                      <div class="data-icon bg-primary bg-opacity-10 mx-auto mb-2">
                        <i class="fas fa-clock text-primary"></i>
                      </div>
                      <div class="data-content text-center">
                        <div class="data-value">{{channelInfo?.stat?.c1counter + channelInfo?.stat?.c2counter}} h</div>
                        <small class="data-label">Totales</small>
                      </div>
                    </div>
                  </div>

                  <!-- Horas Parciales -->
                  <!-- <div class="text-center">
                    <div class="data-item">
                      <div class="data-icon bg-warning bg-opacity-10 mx-auto mb-2">
                        <i class="fas fa-clock text-warning"></i>
                      </div>
                      <div class="data-content text-center">
                        <div class="data-value">{{data.counter.partialHours}} h</div>
                        <small class="data-label">Parciales</small>
                      </div>
                    </div>
                  </div> -->

                  <!-- Horas Salida 1 -->
                  <div class="text-center">
                    <div class="data-item">
                      <div class="data-icon bg-info bg-opacity-10 mx-auto mb-2">
                        <i class="fas fa-lightbulb text-info"></i>
                      </div>
                      <div class="data-content text-center">
                        <div class="data-value">{{channelInfo?.stat?.c1counter}} h</div>
                        <small class="data-label">Salida 1</small>
                      </div>
                    </div>
                  </div>

                  <!-- Horas Salida 2 -->
                  <div class="text-center">
                    <div class="data-item">
                      <div class="data-icon bg-success bg-opacity-10 mx-auto mb-2">
                        <i class="fas fa-lightbulb text-success"></i>
                      </div>
                      <div class="data-content text-center">
                        <div class="data-value">{{channelInfo?.stat?.c2counter}} h</div>
                        <small class="data-label">Salida 2</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- Estado de Salidas -->
        <div class="col-xl-5 col-lg-12 col-md-5 col-sm-12">
          <div class="card flex-fill" style="min-height: 175px;">
            <div class="card-header py-2">
              <h6 class="card-title mb-0 small">
                Estado de Salidas
              </h6>
            </div>
            <div class="card-body py-2 d-flex align-items-center justify-content-center gap-4">
              <!-- Salida 1 -->
              <div class="text-center">
                <div class="mb-2">
                  <i class="fas fa-lightbulb fs-4"
                   [class.text-success]="channelInfo?.stat?.c1stat == 2 || channelInfo?.stat?.c1stat == 3"
                     [class.text-danger]="channelInfo?.stat?.c1stat != 2 && channelInfo?.stat?.c1stat != 3"></i>
                </div>
                <div class="mb-1">
                  <h6 class="mb-0 text-primary fw-bold small d-inline-flex align-items-center gap-2">
                    Salida 1
                    <i class="fa-solid fa-lock text-warning" style="cursor: pointer;"  *ngIf="ancDeviceInfo.permanent == 1 || ancDeviceInfo.permanent == 3" (click)="changePermanentOutput(1, false)"></i>
                    <i class="fa-solid fa-unlock" style="cursor: pointer;" *ngIf="ancDeviceInfo.permanent == 0 || ancDeviceInfo.permanent == 2" (click)="changePermanentOutput(1, true)"></i>
                  </h6>
                </div>
                <div (click)="changeOutput(1)"
                  [class]="channelInfo?.stat?.c1stat == 2 || channelInfo?.stat?.c1stat == 3 ?
                    'border border-success border-2 bg-success bg-opacity-10 text-success rounded-2 d-flex align-items-center justify-content-center fw-bold' :
                    'border border-danger border-2 bg-danger bg-opacity-10 text-danger rounded-2 d-flex align-items-center justify-content-center fw-bold'"
                  style="min-width: 80px; height: 32px; font-size: 0.9rem;">
                  {{channelInfo?.stat?.c1stat == 2 || channelInfo?.stat?.c1stat == 3 ? 'ON' : 'OFF'}}
                  <i class="fa-solid fa-hand-pointer ms-1 text-dark" *ngIf="channelInfo?.stat?.c1stat == 3 || channelInfo?.stat?.c1stat == 1" ></i>
                </div>
              </div>

              <!-- Salida 2 -->
              <div class="text-center">
                <div class="mb-2">
                  <i class="fas fa-lightbulb fs-4"
                     [class.text-success]="channelInfo?.stat?.c2stat == 2 || channelInfo?.stat?.c2stat == 3"
                     [class.text-danger]="channelInfo?.stat?.c2stat != 2 && channelInfo?.stat?.c2stat != 3"></i>
                </div>
                <div class="mb-1">
                  <h6 class="mb-0 text-primary fw-bold small d-inline-flex align-items-center gap-2">
                    Salida 2
                    <i class="fa-solid fa-lock text-warning" style="cursor: pointer;"  *ngIf="ancDeviceInfo.permanent == 2 || ancDeviceInfo.permanent == 3" (click)="changePermanentOutput(2, false)"></i>
                    <i class="fa-solid fa-unlock" style="cursor: pointer;" *ngIf="ancDeviceInfo.permanent == 0 || ancDeviceInfo.permanent == 1" (click)="changePermanentOutput(2, true)"></i>
                  </h6>
                </div>
                <div (click)="changeOutput(2)"
                  [class]="channelInfo?.stat?.c2stat == 2 || channelInfo?.stat?.c2stat == 3 ?
                    'border border-success border-2 bg-success bg-opacity-10 text-success rounded-2 d-flex align-items-center justify-content-center fw-bold' :
                    'border border-danger border-2 bg-danger bg-opacity-10 text-danger rounded-2 d-flex align-items-center justify-content-center fw-bold'"
                  style="min-width: 80px; height: 32px; font-size: 0.9rem;">
                  {{channelInfo?.stat?.c2stat == 2 || channelInfo?.stat?.c2stat == 3 ? 'ON' : 'OFF'}}
                  <i class="fa-solid fa-hand-pointer ms-1 text-dark" *ngIf="channelInfo?.stat?.c2stat == 3 || channelInfo?.stat?.c2stat == 1" ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Columna derecha: Espacio reservado para gráficos (sin implementar por ahora) -->
    <div class="col-lg-6 col-md-12 d-flex flex-column h-100">
      <div class="card flex-fill">
        <div class="card-header py-2">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="card-title mb-0 small">
             Programación Semanal
            </h6>
            <app-out-buttons [numOutputs]="2" (outputChange)="onOutputChange($event)"></app-out-buttons>
            <button
              type="button"
              class="btn btn-sm border text-secondary bg-transparent rounded-pill" style="border-width:1px;"
              (click)="openSchedulerModal()"
              title="Editar programación">
              <i class="fas fa-edit me-1"></i>Editar
            </button>
          </div>
        </div>
        <div class="card-body py-2 flex-fill" [hidden]="hideSchedulerAnc">
          <!-- Componente de programación reutilizable -->
          <app-scheduler-anc
            [schedulerData]="programDataFormated"
            [outputCount]="2"
            [selectedOutput]="selectedOutput"
            [sunTimesData]="sunTimesData"
            chartIdPrefix="chart-anc1">
          </app-scheduler-anc>
        </div>
      </div>
    </div>

  </div>

